import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Space, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ApiService } from '../services/api';
import { LoginRequest } from '../types';

const { Title } = Typography;

const Login: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // 如果用户已经登录，重定向到目标页面
    React.useEffect(() => {
        if (isAuthenticated) {
            const from = (location.state as any)?.from?.pathname || '/dashboard';
            navigate(from, { replace: true });
        }
    }, [isAuthenticated, navigate, location]);

    const onFinish = async (values: LoginRequest) => {
        setLoading(true);
        try {
            const response = await ApiService.login(values);
            if (response.code === 200) {
                login(response.data.token, {
                    user_id: response.data.user_id,
                    username: response.data.username
                });
                message.success('登录成功');

                // 获取用户之前尝试访问的路径，如果没有则默认跳转到dashboard
                const from = (location.state as any)?.from?.pathname || '/dashboard';
                navigate(from, { replace: true });
            } else {
                message.error(response.message || '登录失败');
            }
        } catch (error: any) {
            message.error(error.response?.data?.message || '登录失败，请检查网络连接');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <Card style={{ width: 400, boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <Title level={2} style={{ color: '#1890ff' }}>Pixel Creator</Title>
                    <Title level={4} style={{ color: '#666', marginTop: 0 }}>后台管理系统</Title>
                </div>

                <Form
                    name="login"
                    onFinish={onFinish}
                    autoComplete="off"
                    size="large"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: '请输入用户名!' }]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="用户名"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: '请输入密码!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="密码"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            style={{ width: '100%' }}
                        >
                            登录
                        </Button>
                    </Form.Item>
                </Form>

                <div style={{ textAlign: 'center' }}>
                    <Space>
                        <span>还没有账号？</span>
                        <Link to="/login">联系管理员</Link>
                    </Space>
                </div>
            </Card>
        </div>
    );
};

export default Login; 